export const uniqBy = <T>(arr: Maybe<T[]> | undefined, predicate: string | ((o: T) => string)) => {
  if (!Array.isArray(arr)) return [];

  // @ts-expect-error
  const callback = typeof predicate === "function" ? predicate : (o: T) => o[predicate];

  const pickedObjects = arr
    .filter((item) => item)
    .reduce((map, item) => {
      const key = callback(item);

      if (key) {
        return map.has(key) ? map : map.set(key, item);
      }

      return map;
    }, new Map())
    .values();

  return [...pickedObjects] as T[];
};
